import React from 'react';
import LegalLayout from '../components/LegalLayout';
import { usePageMeta } from '../hooks/usePageMeta';

const SECTIONS = [
  {
    heading: 'Medical disclaimer',
    bullets: [
      'Always talk to your doctor before making changes to your diet, exercise, medicines or treatment, especially if you have a health condition, are pregnant, or are caring for a child or older adult.',
      'Never ignore professional medical advice, or delay seeking it, because of something you read here.',
      'Our guides do not diagnose conditions, recommend medicines or doses, or interpret test results.',
      'Information may change as research and official guidance develop; check the "last updated" date on each guide.',
      'In a medical emergency, call 112 in India, or your local emergency number, or go to the nearest hospital immediately.',
    ],
    after: 'Your use of this site is also governed by our Terms of Use (/terms) and Privacy Policy (/privacy).',
  },
];

export default function MedicalDisclaimer() {
  usePageMeta({
    title: 'Medical disclaimer | OVERALL WELLBEING',
    description:
      'OVERALL WELLBEING provides general wellbeing information for educational purposes only, not medical advice.',
    path: '/medical-disclaimer',
  });

  return (
    <LegalLayout
      testId="medical-disclaimer-page"
      eyebrow="Guidance, not medical advice"
      title="Medical disclaimer"
      intro="OVERALL WELLBEING provides general information about everyday wellbeing for educational purposes only. It is not medical advice and is not a substitute for diagnosis or treatment by a qualified doctor or health professional."
      sections={SECTIONS}
    />
  );
}
